import React, {
    useEffect,
    useState
} from "react";

import {
    Offcanvas
} from "react-bootstrap";

import UserSecurityHeaderCard
    from "./UserSecurityHeaderCard";

import UserSecurityTabs
    from "./UserSecurityTabs";

import userSecurityService
    from "../services/userSecurityService";

const UserSecurityDrawer = ({

    show,

    user,

    onClose

}) => {
    const [permissions, setPermissions] = useState([]);

    const [loading, setLoading] = useState(false);
    const [maximized, setMaximized] = useState(false);
    const loadPermissions = async () => {

        if (!user) {

            return;

        }

        try {

            setLoading(true);

            const data =
                await userSecurityService.getPermissions(

                    user.user_access_mapping_id

                );

            console.log("Permissions:", data);

            setPermissions(data);

        }

        catch (err) {

            console.error(err);

        }

        finally {

            setLoading(false);

        }

    };
    const handleSave = async () => {

    try {

        const dirtyPermissions = permissions.filter(

            permission => permission.dirty

        );

        if (

            dirtyPermissions.length === 0

        ) {

            alert(

                "No changes to save."

            );

            return;

        }

        await userSecurityService.savePermissions(

            user.user_access_mapping_id,

            {

                permissions: dirtyPermissions

            }

        );

        alert(

            "Permissions saved successfully."

        );

        loadPermissions();

    }

    catch (err) {

        console.error(err);

        alert(

            "Failed to save permissions."

        );

    }

};
    useEffect(() => {

        if (

            show &&

            user?.user_access_mapping_id

        ) {

            loadPermissions();

        }

    }, [

        show,

        user

    ]);
    return (

        <Offcanvas

            show={show}

            onHide={onClose}

            placement="end"

            backdrop="static"

            scroll={false}

            style={{

                width: maximized

                    ? "95vw"

                    : "85vw",

                maxWidth: maximized

                    ? "100vw"

                    : "1400px"

            }}

        >

           <div
                    className="border-bottom px-3 py-2 d-flex justify-content-between align-items-center"
                >

                    <h5 className="mb-0">

                        User Security Management

                    </h5>

                    <div className="d-flex align-items-center gap-2">

                    <button
                            className="btn btn-primary btn-sm"
                            onClick={handleSave}
                        >

                            <i className="bi bi-floppy me-1"></i>

                            Save

                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => setMaximized(!maximized)}
                            title={
                                maximized
                                    ? "Restore"
                                    : "Maximize"
                            }
                        >

                            <i
                                className={`bi ${
                                    maximized
                                        ? "bi-fullscreen-exit"
                                        : "bi-fullscreen"
                                }`}
                            />

                        </button>

                        <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={onClose}
                        >

                            <i className="bi bi-x-lg"></i>

                        </button>

                    </div>

                </div>



            <Offcanvas.Body>

                {

                    user &&

                    <>

                        <UserSecurityHeaderCard

                            user={user}

                        />

                        <UserSecurityTabs

                            user={user}

                            permissions={permissions}
                            setPermissions={setPermissions}

                            loading={loading}
                            loadPermissions={loadPermissions}

                        />

                    </>

                }

            </Offcanvas.Body>

        </Offcanvas>

    );

};

export default UserSecurityDrawer;